import { COLOR_TYPE } from '../redux/slicers/admin/curatorStylesSlicer';
const { REACT_APP_VERSION } = process.env;

export const CONFIGURATOR_TYPE = {
  IMAGE: '1',
  THREE_SIXTY: '2',
  THREED_VIEWER: '3',
  UPLOAD_IMAGE: '4',
};

export const ASPECT_RATIO = {
  1.77: '1.77',
  1.33: '1.33',
  1: '1',
};

export const THEME = {
  THEME1: 'THEME1',
  THEME2: 'THEME2',
  THEME3: 'THEME3',
  THEME4: 'THEME4',
};

export const NEW_CONFIGURATOR_ID = 'new';

export const UNITY_REF = {
  loaderUrl: `/Build/configurator/WebGLBuild.loader.js?version=${REACT_APP_VERSION}`,
  dataUrl: `/Build/configurator/WebGLBuild.data?version=${REACT_APP_VERSION}`,
  frameworkUrl: `/Build/configurator/WebGLBuild.framework.js?version=${REACT_APP_VERSION}`,
  codeUrl: `/Build/configurator/WebGLBuild.wasm?version=${REACT_APP_VERSION}`,
};

export const EMPTY_CONFIGURATOR = {
  // use it to provide some default state when configurator data is fetching
  theme: null,
  name: 'Loading...',
  type: CONFIGURATOR_TYPE.IMAGE,
  watermark: false,
  sharing_enabled: false,
  is_download_enabled: false,
  floor_shadow: false,
  aspectRatio: ASPECT_RATIO['1.33'],
  imageWidth: 3072,
  imageHeight: 2304,
};

export const NEW_CONFIGURATOR_DATA = {
  // use it to provide some default state when configurator data is fetching
  id: NEW_CONFIGURATOR_ID,
  theme: THEME.THEME1,
  name: 'Untitled',
  type: CONFIGURATOR_TYPE.IMAGE,
  watermark: false,
  sharing_enabled: false,
  is_download_enabled: false,
  floor_shadow: false,
  aspectRatio: ASPECT_RATIO['1.33'],
  imageWidth: 3072,
  imageHeight: 2304,
};

export const CONFIGURATOR_Z_INDEX = {
  DATA_LOADER: 100,
};

export const CONFIGURATOR_CONSTANT = {
  CAMERA: {
    FOV_MIN: 10,
    FOV_MAX: 80,
    DISTANCE_MIN: 0,
    DISTANCE_MAX: 25,
    HEIGHT_MIN: -3,
    HEIGHT_MAX: 3,
    ROTATION_Z_MIN: -50,
    ROTATION_Z_MAX: 90,
    ROTATION_MIN: 0,
    ROTATION_MAX: 360,
    HORIZONTAL_PANNING_MIN: -50,
    HORIZONTAL_PANNING_MAX: 50,
    VERTICAL_PANNING_MIN: -50,
    VERTICAL_PANNING_MAX: 50,
  },
  SCALE: {
    MIN: 100,
    MAX: 650,
  },
  SHADOW_OPACITY: {
    MIN: 0,
    MAX: 1,
  },
};

export const BACKGROUND_TYPE = {
  IMAGE: '1',
  COLOR: '2',
};

export const BACKGROUD_FIT = {
  FILL: '1',
  CROP: '2',
};
export const OPTION_TYPE = {
  MATERIAL: '2',
  TEXTURE: '1',
  COLOR: '3',
  PROPERTIES: '4',
};

export const OPTION_TYPE_LABEL = {
  [OPTION_TYPE.MATERIAL]: 'Material',
  [OPTION_TYPE.TEXTURE]: 'Texture',
  [OPTION_TYPE.COLOR]: 'Color',
};

export const DRAGGABLE_TYPE = {
  LABEL: 'LABEL',
  OBJECT: 'OBJECT',
};

export const MIN_IMAGE_SIZE = 1;
export const MAX_IMAGE_SIZE = 5000;

export const DEFAULT_FOV = 20;

export const EMPTY_VIEW = {
  is_bg: false,
  applyToAllViews: false,
  backgroundType: BACKGROUND_TYPE.IMAGE,
  backgroundFit: BACKGROUD_FIT.FILL,
  backgroundImage: null,
  backgroundImageCropped: null,
  colorType: COLOR_TYPE.HEX,
};

export const EMPTY_SCENE = {};

export const EMPTY_ARRAY = [];

export const CAROUSEL_CONSTANT_HEIGHT = 128;

export const CAROUSEL_CONSTANT_HEIGHT_VIEWER = 70;

export const PADDING_VALUE_VIEWER = 16;

export const MAX_CAMERA_ANGLES = 10;

export const MIN_IMAGE_WIDTH_HEIGHT = 1500;

export const MAX_ALLOWED_THUMBNAIL_SIZE = 5000000;

export const MAX_ALLOWED_UPLOAD_THUMBNAIL_SIZE = 1000000;

export const ALL_COMBINED_CONFIGURATOR = 'ALL_COMBINED_CONFIGURATOR';
export const CLOSED_CURATOR_WINDOW = 'CLOSED_CURATOR_WINDOW';
export const UPDATE_SCENE_DATA_CONFIGURATOR = 'UPDATE_SCENE_DATA_CONFIGURATOR';
export const UPDATED_LIFESTYLE_JSON_FROM_CURATOR = 'UPDATED_LIFESTYLE_JSON_FROM_CURATOR';
export const SILO_ROOM_TYPE = '3';
export const NEW_LIGHTROOM_CREATED = 'NEW_LIGHTROOM_CREATED';
export const INITIALIZED_CURATOR_LIGHTROOM_ID = 'INITIALIZED_CURATOR_LIGHTROOM_ID';
export const LIGHTROOM_ID = 'LIGHTROOM_ID';
export const COMBINED_CONFIGURATOR_ROOM_DATA = 'COMBINED_CONFIGURATOR_ROOM_DATA';
export const CURRENT_CURATOR_LIGHTROOM_PARAMS = 'CURRENT_CURATOR_LIGHTROOM_PARAMS';
export const EIGHT_HOURS = 28800000;

export const UPDATE_CONFIGURATOR_IFRAME = 'UPDATE_CONFIGURATOR_IFRAME';

export const IMAGE = {
  jpg: {
    image_low: 'jpg_image_low',
    image: 'jpg_image',
  },
  png: {
    image_low: 'image_low',
    image: 'image',
  },
};

export const RADIAL_DATA = [
  0, 359, 358, 357, 356, 355, 354, 353, 352, 351, 350, 349, 348, 347, 346, 345, 344, 343, 342, 341,
  340, 339, 338, 337, 336, 335, 334, 333, 332, 331, 330, 329, 328, 327, 326, 325, 324, 323, 322,
  331, 320, 319, 318, 317, 316, 315, 314, 313, 312, 311, 310, 309, 308, 307, 306, 305, 304, 303,
  302, 301, 300, 299, 298, 297, 296, 295, 294, 293, 292, 291, 290, 289, 288, 287, 286, 285, 284,
  283, 282, 281, 280, 279, 278, 277, 276, 275, 274, 273, 272, 271, 270, 269, 268, 267, 266, 265,
  264, 263, 262, 261, 260, 259, 258, 257, 256, 255, 254, 253, 252, 251, 250, 249, 248, 247, 246,
  245, 244, 243, 242, 241, 240, 239, 238, 237, 236, 235, 234, 233, 232, 231, 230, 229, 228, 227,
  226, 225, 224, 223, 222, 221, 220, 219, 218, 217, 216, 215, 214, 213, 212, 211, 210, 209, 208,
  207, 206, 205, 204, 203, 202, 201, 200, 199, 198, 197, 196, 195, 194, 193, 192, 191, 190, 189,
  188, 187, 186, 185, 184, 183, 182, 181, 180, 179, 178, 177, 176, 175, 174, 173, 172, 171, 170,
  169, 168, 167, 166, 165, 164, 163, 162, 161, 160, 159, 158, 157, 156, 155, 154, 153, 152, 151,
  150, 149, 148, 147, 146, 145, 144, 143, 142, 141, 140, 139, 138, 137, 136, 135, 134, 133, 132,
  131, 130, 129, 128, 127, 126, 125, 124, 123, 122, 121, 120, 119, 118, 117, 116, 115, 114, 113,
  112, 111, 110, 109, 108, 107, 106, 105, 104, 103, 102, 101, 100, 99, 98, 97, 96, 95, 94, 93, 92,
  91, 90, 89, 88, 87, 86, 85, 84, 83, 82, 81, 80, 79, 78, 77, 76, 75, 74, 73, 72, 71, 70, 69, 68,
  67, 66, 65, 64, 63, 62, 61, 60, 59, 58, 57, 56, 55, 54, 53, 52, 51, 50, 49, 48, 47, 46, 45, 44,
  43, 42, 41, 40, 39, 38, 37, 36, 35, 34, 33, 32, 31, 30, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20,
  19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1,
];

export const DEFAULT_START_ANGLE = 0;
export const DEFAULT_END_ANGLE = 360;
export const DEFAULT_CURRENT_ANGLE = 180;

export const DEFAULT_FRAMES = 24;

export const GLASS_MATERIAL_ID = 895;
export const GLASS_MATERIAL_OPTION_NAME = 'glass';

export const LOADING_DELAY = 1000;

export const PROTOTYPE_MESSAGES = [
  'Setting things up for you...',
  'Optimizing your experience...',
  'Bringing your design to life...',
];

export const INITIAL_STORE_SETUP_MESSAGES = [
  'Initialising the retail project',
  // 'Loading the stores for you'
]

export const INITIAL_STORE_SETUP_MESSAGES_FOR_RC = [
  'Setting up environment',
  'Loading POS templates',
];

export const DEFAULT_FONT_SIZE = 12;

export const DEFAULT_FONT_COLOR = "#282828";

export const DEFAULT_THEME_BACKGROUND_COLOR = "#FFFFFF";

export const OTHER_THEME_BACKGROUND_COLOR = "#FAF6EB";

export const FONT_OPTIONS = [
  { label: '6px', value: 6 },
  { label: '8px', value: 8 },
  { label: '10px', value: 10 },
  { label: '12px', value: 12 },
];

export const DEFAULT_SORT_BY = 'seq_no';

export const DEFAULT_DOWNLOAD_POSITION = 'BOTTOM_RIGHT';

export const SORT_OPTIONS = [
  { label: 'None', value: 'seq_no' },
  { label: 'Name: A to Z', value: 'name' },
  { label: 'Name: Z to A', value: '-name' },
];

export const DOWNLOAD_OPTIONS = [
  { label: 'Top Left', value: 'TOP_LEFT' },
  { label: 'Top Right', value: 'TOP_RIGHT' },
  { label: 'Bottom Left', value: 'BOTTOM_LEFT' },
  { label: 'Bottom Right', value: 'BOTTOM_RIGHT' },
];
